/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ApiConfig} from "../../api";
import {Injectable} from '@angular/core';
import {AdnHttpService} from '../../../util/adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

export interface AuditHistoryQuery {
  pageSize?: number;
  page?: number;
  startDate?: any;
  endDate?: any;
  chartMode?: boolean;
}

export interface AuditHistoryPage {
  results: any[];
  totalCount: number;
}

@Injectable()
export class AuditResource {
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  get(
    domainObject: any,
    objectType: string | undefined,
    query: AuditHistoryQuery = {}
  ): Promise<AuditHistoryPage> {
    const versionedUri = ApiConfig.obtain().getVersionedUri(['audithistory', domainObject.id]);
    const params: Record<string, any> = {
      objectType,
      pageSize: query.pageSize || 25,
      page: query.page || 1
    };
    if (query.startDate) {
      params.startDate = query.startDate;
    }
    if (query.endDate) {
      params.endDate = query.endDate;
    }
    if (query.chartMode) {
      params.queryOption = 'SINCE_RUNNING_DATE';
      params.auditType = 'DIRECT_DELIVERY_IMPACT';
    }

    return this.send({method: 'GET', url: versionedUri, params});
  }
}
